export const MINI_EXPANDED_WIDTH_PCT = 0.35;
export const MINI_EXPANDED_HEIGHT_PCT = 0.65;

export const MINI_COLLAPSED_WIDTH_PCT = 0.25;
export const MINI_COLLAPSED_HEIGHT = 56;

export const MINI_MARGIN = 16;

export const OVERLAY_MAX_WIDTH = 1100;
export const getMiniExpandedSize = (width: number, height: number) => ({
	width: width * MINI_EXPANDED_WIDTH_PCT,
	height: height * MINI_EXPANDED_HEIGHT_PCT
});

export const getMiniCollapsedSize = (width: number) => ({
	width: width * MINI_COLLAPSED_WIDTH_PCT,
	height: MINI_COLLAPSED_HEIGHT
});
